document.addEventListener('DOMContentLoaded', function () {
  const main = document.getElementById('main-content');
  const target = main?.querySelector('page');

  if (main && target) {
    const skipLink = document.createElement('a');
    skipLink.href = '#main-content';
    skipLink.className = 'skip-link';
    skipLink.textContent = document.documentElement.lang == "de" ? "Zum Inhalt springen" : "Skip to content";

    skipLink.addEventListener('click', function (e) {
      e.preventDefault();
      const focusable = target.querySelector(
        'a[href]:not([hidden]):not(.form-row *), ' +
        'button:not([disabled]):not([hidden]):not(.form-row *), ' +
        'input:not([disabled]):not([type="hidden"]):not([hidden]):not(.form-row *), ' +
        'textarea:not([hidden]):not(.form-row *), ' +
        'select:not([hidden]):not(.form-row *), ' +
        '[tabindex]:not([tabindex="-1"]):not([hidden]):not(.form-row *):not(.form-row)'
      ) as HTMLElement;

      if (focusable) {
        focusable.focus({ preventScroll: true });
      } else {
        // fallback
        target.setAttribute('tabindex', '-1');
        (target as HTMLElement).focus({ preventScroll: true });
      }

      skipLink.blur();
    });

    document.getElementById('skip-link-container')?.appendChild(skipLink);
  }
});

